// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__11g_B","header":"PatientQuestionnaire_header__3CjqK","info":"PatientQuestionnaire_info__3g-_r"};